import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo'
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: Date | string, referenceDate?: Date | string): string {
    if (!value) return '';
    const selectedLanguage = localStorage.getItem('lang');
    const now = typeof referenceDate === 'string'
        ? new Date(referenceDate)
        : referenceDate instanceof Date
            ? referenceDate
            : new Date();
    const date = value instanceof Date ? value : new Date(value);
    const seconds = Math.floor((+now - +date) / 1000);
    const intervals: any = {
      minuto: 60,
    };
    for (const i in intervals) {
      const counter = Math.floor(seconds / intervals[i]);
      if (counter > 0) {
        switch (selectedLanguage) {
          case 'en':
            return `${counter} min ago`;
          case 'es':
            return `${counter} min`;
          case 'ptbr':
            return `${counter} min antes`;
          default:
            return `${counter} min ago`;
        }
      }
    }
    switch (selectedLanguage) {
      case 'en':
        return '0 min ago';
      case 'es':
        return '0 min antes';
      case 'ptbr':
        return '0 min antes';
      default:
        return '0 min ago';
    }
  }
}
